// Venue-search VS1.3: words in the venue editor that are not field labels.
// Approved by Braeden in the VS1.3 plan (2026-11-02) and the VS1.4 plan (2026-11-03). Field labels, "?"
// definitions and help text come from the field dictionary (src/taxonomy).
const copy = {
  yes: 'Yes',
  no: 'No',
  showDefinition: (label) => `What is "${label}"?`,
  photosMinimum: (min) => `Please upload a minimum of ${min} photos`,
  tooLong: (max, count) => `Use ${max} characters or fewer. You have ${count}.`,
  venueType: 'Venue type',
  guests: {
    title: 'Guests',
    squareFootage: 'Square footage (optional)',
    squareFootageHelp: 'We use it to estimate how many guests fit. You can change the numbers.',
    maxGuests: (n) => `Max guests: ${n}. This is the largest number above.`
  },
  restrooms: 'Restrooms',
  kitchen: 'Kitchen',
  features: { title: 'Spaces and features', intro: 'Answer Yes or No for each one.' },
  lights: { which: 'Which lights? (optional)', where: 'Where:' },
  // VS1.4, approved by Braeden in the VS1.4 plan (2026-11-03).
  inventory: {
    title: 'Items at the venue (optional)',
    intro: 'Check the items you have for events. Bookers see what comes with the day price and what they can rent.',
    otherName: 'What is it?',
    otherKind: 'Describe the kind',
    otherSize: 'Describe the size',
    clothSize: 'The size of the cloth, not the table.',
    note: 'Note (optional)',
    addAnother: '+ Add another kind',
    remove: 'Remove',
    errors: {
      count: 'Enter how many.',
      pricing: 'Pick Included or Costs extra.',
      item: 'Enter the item name.',
      kind: 'Describe the kind.',
      size: 'Describe the size.'
    }
  },
  alsoAtVenue: 'Also at the venue (optional)',
  parking: {
    title: 'Parking',
    intro: 'How many cars can park for an event? Enter 0 if none.',
    total: (n) => `Total: ${n} parking spaces`
  },
  rules: 'Rules',
  eventTypes: {
    title: 'Event types',
    question: 'Are any event types not allowed at this venue?',
    which: 'Which ones?',
    otherText: 'Which other event types?',
    pickOne: 'Pick at least one.'
  },
  overnight: { title: 'Overnight stay', question: 'Can guests stay overnight?', noBeds: 'Add at least 1 bed.' },
  pricing: {
    hoursIncluded: 'Hours included',
    endBeforeStart: 'The end time must be after the start time.',
    tooShort: 'A day must be at least 8 hours.'
  },
  contact: { name: 'Name', phone: 'Phone', badPhone: 'Enter a 10-digit US phone number.' },
  requirements: {
    title: 'Confirm the requirements',
    intro: 'Check each one to save your venue.',
    error: 'Check all 5 to save.',
    questions: 'Cannot confirm one? Email',
    email: 'support@yedding.com'
  },
  fillRequired: 'Please fill out the fields marked in red.'
};

export default copy;
